module.exports = [{ title: 'query', path: 'query' }]
